<button #vm if="maintenance" class="button-style" (click)="open(viewMaintainenance)"></button>
<button #check if="maintenance" class="button-style" (click)="open(viewChecklist)"></button>
<button
class="button-style"
  #cbm
  if="maintenance"
  (click)="open(viewcbMaintainenance)"
></button>
<button #tbm if="maintenance" class="button-style" (click)="open(viewtbmMaintenance)"></button>
<button #pm if="maintenance" class="button-style" (click)="open(viewpmMaintenance)"></button>
<ng-template #viewcbMaintainenance let-modal>
  <!-- <div class="modal-dialog" style="margin: 0px !important" role="document">
    <div class="modal-content"> -->
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          Condition Based Monitor
          <span 
            >[ {{ predictiveList[0].asset }} >
            {{ predictiveList[0].equipmentName }} ]</span
          >
        </h5>
        <i class="fa fa-times" aria-hidden="true" (click)="modal.dismiss('Cross click')"></i>
      </div>
      <div class="modal-body" style="padding: 20px 15px">
        <ng-container>
          <table id="alerts">
            <tr class="header">
              <th *ngFor="let header of headerList">
                {{ header.columnName }}
              </th>
              <th>Actions</th>
            </tr>
            <ng-container *ngFor="let point of predictiveList; let i = index">
              <tr class="acc">
                <td *ngFor="let header of headerList">
                  <ng-container *ngIf="header.columnId == 'frequency'">
                    {{ point[header.columnId].name }}
                  </ng-container>
                  <ng-container *ngIf="header.columnId == 'lastMaintenanceDate'">
                    
                    {{formatDate(point[header.columnId])}}
                  </ng-container>
                  <ng-container *ngIf="header.columnId == 'nextMaintenanceDate'">
                    {{formatDate(point[header.columnId])}}
                  </ng-container>
                  <ng-container
                    *ngIf="
                      header.columnId != 'frequency' &&
                      header.columnId != 'nextMaintenanceDate' &&
                      header.columnId != 'lastMaintenanceDate'
                    "
                  >
                    {{ point[header.columnId] }}
                  </ng-container>
                </td>
                <td style="width: 5%" (click)="[toggleFunc(i)]">
                  <i class="fa fa-angle-down" *ngIf="activeField[i]"></i>
                  <i class="fa fa-angle-up" *ngIf="!activeField[i]"></i>
                </td>
              </tr>

              <tr
                class="acc-panel"
                [ngClass]="!activeField[i] ? 'active' : 'inactive'"
              >
                <td colspan="5">
                  <div class="acc-expand">
                    <div
                      class="innerlist row"
                      style="
                        align-items: baseline !important;
                        border-bottom: 1px solid #eeeeee;
                      "
                    >
                      <ng-container *ngIf="point.maintenanceHistory">
                        <div class="col">
                          <label>Maintenance Date</label>
                        </div>
                        <div class="col">
                          <label>Done By</label>
                        </div>
                        <div class="col">
                          <label>Specification</label>
                        </div><div class="col">
                          <label>Actual Value</label>
                        </div>
                        <div class="col">
                          <label>Remarks</label>
                        </div>
                        
                        <!-- <div class="col">
                          <label>Action</label>
                        </div> -->
                      </ng-container>
                      <ng-container *ngIf="!point.maintenanceHistory">
                        <div style="margin: 0px 40%">
                          No Maintenance History
                        </div>
                      </ng-container>
                    </div>
                    <div
                      class="row"
                      style="padding: 10px 0px"
                      *ngFor="
                        let field of point.maintenanceHistory;
                        let i = index
                      "
                    >
                      <div class="col">
                        {{ field["maintenanceDate"] | date: "dd-MMM-YYYY" }}
                      </div>
                      <div class="col">
                        {{ field["person"] }} {{ field["email"] }}
                      </div>
                      <div class="col">
                        {{ formatSpecification(field) }}
                      </div>
                      <div class="col">
                        {{ field["actualValue"] }} {{field['unit']}}
                      </div>
                      <!-- <div class="col">
                        {{ field["manpower"] }}
                      </div>
                      <div class="col">
                        {{ field["time_taken"] }}
                      </div> -->
                      <div class="col">
                        {{ field["remarks"] ? field["remarks"] : "---" }}
                      </div>
                      <!-- <div class="col">
                        <i
                        title="Edit"
                        class="fas fa-edit font-icon"
                        style="padding: 10px;"
                        (click)="open(viewcbMaintainenance)"
                      ></i>
                        <i
                          class="fa fa-trash cursor-pointer"
                          (click)="predictiveMaintenanceDelete(point, i)"
                        ></i>
                      </div> -->
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </table>
        </ng-container>
        <div><span></span></div>
      </div>
    <!-- </div>
  </div> -->
</ng-template>
<ng-template #viewpmMaintenance let-modal>
  <!-- <div class="modal-dialog" style="margin: 0px !important" role="document">
    <div class="modal-content"> -->
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          Time Based Monitor
          <span style="font-weight: 600"
            >[ {{ predictiveList[0].asset }} >
            {{ predictiveList[0].equipmentName }} ]</span
          >
        </h5>
        <!-- <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button> -->
        <i class="fa fa-times" aria-hidden="true" (click)="modal.dismiss('Cross click')"></i>
      </div>
      <div class="modal-body" style="padding: 20px 15px">
        <ng-container>
          <table id="alerts">
            <tr class="header">
              <th *ngFor="let header of pmheaderList">
                {{ header.columnName }}
              </th>
              <th>Actions</th>
            </tr>
            <ng-container *ngFor="let point of predictiveList; let i = index">
              <tr class="acc">
                <td *ngFor="let header of pmheaderList">
                  <ng-container *ngIf="header.columnId == 'frequency'">
                    {{ point[header.columnId] }}
                  </ng-container>
                  <ng-container *ngIf="header.columnId == 'plannedDate'">
                   {{formatDate(point[header.columnId] )}}
                  </ng-container>
                  <ng-container *ngIf="header.columnId == 'lastMaintenanceDate'">
                    {{formatDate(point[header.columnId] )}}
                  </ng-container>
                  <ng-container
                    *ngIf="
                      header.columnId != 'frequency' &&
                      header.columnId != 'lastMaintenanceDate' &&
                      header.columnId != 'plannedDate'
                    "
                  >
                    {{ point[header.columnId] }}
                  </ng-container>
                </td>
                <td style="width: 5%" (click)="[toggleFunc(i)]">
                  <i class="fa fa-angle-down" *ngIf="activeField[i]"></i>
                  <i class="fa fa-angle-up" *ngIf="!activeField[i]"></i>
                </td>
              </tr>

              <tr
                class="acc-panel"
                [ngClass]="!activeField[i] ? 'active' : 'inactive'"
              >
                <td colspan="5">
                  <div class="acc-expand">
                    <div
                      class="innerlist row"
                      style="
                        align-items: baseline !important;
                        border-bottom: 1px solid #eeeeee;
                      "
                    >
                      <ng-container *ngIf="point.maintenanceHistory">
                        <div class="col">
                          <label>Maintenance Date</label>
                        </div>
                        <div class="col">
                          <label>Done By</label>
                        </div>
                        <div class="col">
                          <label>Remarks</label>
                        </div>
                        <div class="col">
                          <label>Status</label>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="!point.maintenanceHistory">
                        <div style="margin: 0px 40%">
                          No Maintenance History
                        </div>
                      </ng-container>
                    </div>
                    <div
                      class="row"
                      style="padding: 10px 0px"
                      *ngFor="
                        let field of point.maintenanceHistory;
                        let i = index
                      "
                    >
                      <div class="col">
                        {{ field["maintenanceDate"] | date: "dd-MMM-YYYY" }}
                      </div>
                      <div class="col">
                        {{ field["person"] }} {{ field["email"] }}
                      </div>
                      <div class="col">
                        {{ field["remarks"] ? field["remarks"] : "---" }}
                      </div>
                      <div class="col">
                        {{ field["status"] ? field["status"] : "---" }}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </table>
        </ng-container>
        <div><span></span></div>
      </div>
    <!-- </div>
  </div> -->
</ng-template>
<ng-template #viewtbmMaintenance let-modal>
  <!-- <div class="modal-dialog" style="margin: 0px !important" role="document">
    <div class="modal-content"> -->
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          Time Based Monitor
          <span style="font-weight: 600"
            >[ {{ predictiveList[0].asset }} >
            {{ predictiveList[0].equipmentName }} ]</span
          >
        </h5>
        <!-- <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button> -->
        <i class="fa fa-times" aria-hidden="true" (click)="modal.dismiss('Cross click')"></i>
      </div>
      <div class="modal-body" style="padding: 20px 15px">
        <ng-container>
          <table id="alerts">
            <tr class="header">
              <th *ngFor="let header of tbmheaderList">
                {{ header.columnName }}
              </th>
              <th>Actions</th>
            </tr>
            <ng-container *ngFor="let point of predictiveList; let i = index">
              <tr class="acc">
                <td *ngFor="let header of tbmheaderList">
                  <ng-container *ngIf="header.columnId == 'frequency'">
                    {{ point[header.columnId].name }}
                  </ng-container>
                  <ng-container *ngIf="header.columnId == 'plannedDate'">
                   {{formatDate(point[header.columnId] )}}
                  </ng-container>
                  <ng-container *ngIf="header.columnId == 'lastMaintenanceDate'">
                    {{formatDate(point[header.columnId] )}}
                  </ng-container>
                  <ng-container
                    *ngIf="
                      header.columnId != 'frequency' &&
                      header.columnId != 'lastMaintenanceDate' &&
                      header.columnId != 'plannedDate'
                    "
                  >
                    {{ point[header.columnId] }}
                  </ng-container>
                </td>
                <td style="width: 5%" (click)="[toggleFunc(i)]">
                  <i class="fa fa-angle-down" *ngIf="activeField[i]"></i>
                  <i class="fa fa-angle-up" *ngIf="!activeField[i]"></i>
                </td>
              </tr>

              <tr
                class="acc-panel"
                [ngClass]="!activeField[i] ? 'active' : 'inactive'"
              >
                <td colspan="5">
                  <div class="acc-expand">
                    <div
                      class="innerlist row"
                      style="
                        align-items: baseline !important;
                        border-bottom: 1px solid #eeeeee;
                      "
                    >
                      <ng-container *ngIf="point.maintenanceHistory">
                        <div class="col">
                          <label>Maintenance Date</label>
                        </div>
                        <div class="col">
                          <label>Done By</label>
                        </div>
                        <!-- <div class="col">
                          <label>Specification</label>
                        </div>
                        <div class="col">
                          <label>Actual Value</label>
                        </div> -->
                        <!-- <div class="col">
                          <label>Manpower (Nos)</label>
                        </div>
                        <div class="col">
                          <label>Time Taken (Hrs)</label>
                        </div> -->
                        <div class="col">
                          <label>Remarks</label>
                        </div>
                        <div class="col">
                          <label>Status</label>
                        </div>
                        <!-- <div class="col">
                          <label>Action</label>
                        </div> -->
                      </ng-container>
                      <ng-container *ngIf="!point.maintenanceHistory">
                        <div style="margin: 0px 40%">
                          No Maintenance History
                        </div>
                      </ng-container>
                    </div>
                    <div
                      class="row"
                      style="padding: 10px 0px"
                      *ngFor="
                        let field of point.maintenanceHistory;
                        let i = index
                      "
                    >
                      <div class="col">
                        {{ field["maintenanceDate"] | date: "dd-MMM-YYYY" }}
                      </div>
                      <div class="col">
                        {{ field["person"] }} {{ field["email"] }}
                      </div>
                      <!-- <div class="col">
                        {{ field["specification"] }}
                      </div>
                      <div class="col">
                        {{ field["actualValue"] }}
                      </div> -->
                      <!-- <div class="col">
                        {{ field["manpower"] }}
                      </div>
                      <div class="col">
                        {{ field["time_taken"] }}
                      </div> -->
                      <div class="col">
                        {{ field["remarks"] ? field["remarks"] : "---" }}
                      </div>
                      <div class="col">
                        {{ field["status"] ? field["status"] : "---" }}
                      </div>
                      <!-- <div class="col">
                        <i
                          class="fa fa-trash cursor-pointer"
                          (click)="predictiveMaintenanceDelete(point, i)"
                        ></i>
                      </div> -->
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </table>
        </ng-container>
        <div><span></span></div>
      </div>
    <!-- </div>
  </div> -->
</ng-template>

<ng-template #viewMaintainenance let-modal>
  <!-- <div class="modal-dialog" style="margin: 0px !important" role="document">
    <div class="modal-content"> -->
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel" style="font-size: 15px; font-family:'sfpro-r'">
          Breakdown Maintenance
        </h5>
        <!-- <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button> -->
        <i class="fa fa-times" aria-hidden="true" (click)="modal.dismiss('Cross click')"></i>
      </div>
      <div class="modal-body" style="padding: 20px 15px">
        <ng-container>
          <div class="row">
            <div class="col-7" style="border-right: 1px solid #eeeeee">
              <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Equipment Name</div>
                <div class="col-6">
                  {{ equipmentPath ? equipmentPath : "NA" }}
                </div>
              </div>
              <!-- <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Corrective Action Date</div>
                <div class="col-6">
                  {{
                    formatDate(
                      lastMaintenance?.maintenanceDate
                        ? lastMaintenance.maintenanceDate
                        : "NA"
                    )
                  }}
                </div>
              </div> -->
              <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Breakdown Date</div>
                <div class="col-6">
                  {{
                    formatDate(
                      lastMaintenance?.breakdownDate
                        ? lastMaintenance.breakdownDate
                        : "NA"
                    )
                  }}
                </div>
              </div>
              <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Reason For Loss</div>
                <div class="col-6">
                  {{
                    lastMaintenance?.reasonForLoss
                      ? lastMaintenance.reasonForLoss
                      : "NA"
                  }}
                </div>
              </div>
              <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Loss Time (Mins)</div>
                <div class="col-6">
                  {{
                    lastMaintenance?.timeTaken
                      ? lastMaintenance.timeTaken + " Mins"
                      : "NA"
                  }}
                </div>
              </div>
              <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Analysis</div>
                <div class="col-6">
                  {{
                    lastMaintenance?.analysis
                      ? lastMaintenance.analysis
                      : "NA"
                  }}
                </div>
              </div>
              <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Corrective Action Taken</div>
                <div class="col-6">
                  {{
                    lastMaintenance?.correctiveActionTaken
                      ? lastMaintenance.correctiveActionTaken
                      : "NA"
                  }}
                </div>
              </div>
              <!-- <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Manpower</div>
                <div class="col-6">
                  {{
                    lastMaintenance?.manpower ? lastMaintenance.manpower : "NA"
                  }}
                </div>
              </div> -->
              <!-- <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Observations/Reasons</div>
                <div class="col-6">
                  {{
                    lastMaintenance?.observations
                      ? lastMaintenance.observations
                      : "NA"
                  }}
                </div>
              </div> -->
              <!-- <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Section</div>
                <div class="col-6">
                  {{ lastMaintenance?.agency ? lastMaintenance.agency : "NA" }}
                </div>
              </div> -->
              <!-- <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Area</div>
                <div class="col-6">
                  {{ lastMaintenance?.area ? lastMaintenance.area : "NA" }}
                </div>
              </div> -->
              <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Permanent Action</div>
                <div class="col-6">
                  {{
                    lastMaintenance?.permanentActionTaken
                      ? lastMaintenance.permanentActionTaken
                      : "NA"
                  }}
                </div>
              </div>
              <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Target Date</div>
                <div class="col-6">
                  {{
                    formatDate(
                      lastMaintenance?.targetDate
                        ? lastMaintenance.targetDate
                        : "NA"
                    )
                  }}
                </div>
              </div>
              <!-- <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Criticality</div>
                <div class="col-6">
                  {{
                    lastMaintenance?.criticality
                      ? lastMaintenance.criticality
                      : "NA"
                  }}
                </div>
              </div> -->
              <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Responsible Person</div>
                <div class="col-6">
                  {{
                    lastMaintenance?.responsiblePerson
                      ? lastMaintenance.responsiblePerson
                      : "NA"
                  }}
                </div>
              </div>
              <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Maintenance Done By</div>
                <div class="col-6">
                  <!-- {{
                    lastMaintenance.person || lastMaintenance.email
                      ? lastMaintenance.person + " " + lastMaintenance.email
                      : "NA"
                  }} -->
                  {{
                    lastMaintenance?.maintenanceDoneBY
                      ? lastMaintenance.maintenanceDoneBY
                      : "NA"
                  }}
                </div>
              </div>
              <!-- <div class="row" style="padding: 15px 5px">
                <div class="col-6 headerStyle">Vendor</div>
                <div class="col-6">
                  {{
                    lastMaintenance?.newVendor
                      ? lastMaintenance.newVendor
                      : "NA"
                  }}
                </div>
              </div> -->
            </div>
            <div class="col-5">
              <div
                class="row"
                style="
                  border-bottom: 1px solid #eeeeee;
                  padding: 20px 5px;
                  margin-right: 10px;
                "
              >
                <div class="col-10 input">
                  <form [formGroup]=commentForm>
                    <div class="label">Comments</div>
                    <input type="text" [(ngModel)]="comments" class="wid100" formControlName="comments" />
                  </form>
                </div>
                <div class="col-2">
                  <button
                    style="margin-top: 20px;
                    height: 28px;
                    width: max-content;" 
                    [disabled]="!comments"               
                    (click)="addComents()"
                    class="btn btn-primary"
                  >
                    <span style="
                    position: relative;
                    bottom: 4px;">Save</span>
                  </button>
                </div>
              </div>
              <div
                *ngIf="lastMaintenance?.comments?.length"
                class="row"
                style="
                  padding: 10px 5px;
                  border-bottom: 1px solid #eeeeee;
                  margin-right: -40px;
                "
              >
                <div class="col-4">Comments</div>
                <div class="col-4">Comments By</div>
                <div class="col-4">Timestamp</div>
                <!-- <div class="col-2" style="margin-left: -25px;">Action</div> -->
              </div>
              <ng-container *ngFor="let data of lastMaintenance.comments">
                <div class="row" style="padding-top: 5px ">
                  <div class="col-4">{{ data.comment }}</div>
                  <div class="col-4">
                    {{ data.commentsBy }}
                  </div>
                  <div class="col-4">
                    {{ data.timestamp | date: "short" }}
                  </div>
                  <!-- <div class="col-2">
                    <i
                    title="Edit"
                    style="padding-right:10px;"
                    class="fas fa-edit font-icon"
                    (click)="editcomments(data)"
                  ></i>
                  <i
                          class="fa fa-trash font-icon"
                          aria-hidden="true"
                          (click)="deleteComments()"
                        ></i>
                  </div> -->
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>
        <div><span></span></div>
      </div>
    <!-- </div>
  </div> -->
</ng-template>
<ng-template style="max-width: 1200px !important" #viewChecklist let-modal>
  <!-- <div class="modal-dialog" style="margin: 0px !important" role="document">
    <div class="modal-content"> -->
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          Checklist
          <span style="font-size: 15px; font-family: 'sfpro-r';">[{{ checklist.checklist_name }}]</span>
        </h5>
        <!-- <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button> -->
        <i class="fa fa-times" aria-hidden="true" (click)="modal.dismiss('Cross click')"></i>
      </div>
      <div class="modal-body" style="padding: 20px 15px">
        <div style="    padding-bottom: 23px;
        display: flex;
        justify-content: end">
          <button 
        class="btn btn-default custom-btn"
        style="margin: 0px 10px;
        height: 30px;
        padding: 9px 10px 2px 10px;"
        (click)="downloadData(checklist.id)"
      >
       <span style="
       position: relative;
       bottom: 4px;">Download</span> 
      </button>

        </div>
        <div class="d-fc p-20" [id] = "checklist.id" >
          <div class="datatableWidget">
            <!-- <div class="checklist-title"></div> -->
            <div>
              <div  class="checklistDetails">
                <!-- <div>
                  <span class="label-color">Asset: </span>{{ checklist.asset }}
                </div> -->
                <div>
                  <span class="label-color">Category: </span
                  >{{ checklist.category }}
                </div>
                <div>
                  <span class="label-color">Frequency: </span
                  >{{ checklist.frequency }}
                </div>
                <div>
                  <span class="label-color">Checked By: </span
                  >{{ checklist?.email ? checklist.email : "None" }}
                </div>
                <div>
                  <span class="label-color">Date: </span
                  >{{ formatDate(checklist.maintenanceDate) }}
                </div>
              </div>
              <div
                style="
                  display: flex;
                  flex-wrap: wrap;
                  border-bottom: 1px solid #eeeeee;
                  margin-bottom: 10px;
                  align-items: center;
                "
                *ngIf="checklist.metaData"
              >
                <ng-container *ngFor="let data of checklist.metaData">
                  <div style="margin: 5px 5px; min-width: fit-content">
                    <span class="label-color">{{ data.columnName }} : </span>
                    <ng-container *ngIf = "checklist.view_type == 'defect_sheet'">
                    <span *ngIf = "data.columnName == 'Model'">{{ data.value ? data.value.text : "NA" }}</span>
                    <span *ngIf = "data.columnName != 'Model'">{{ data.value ? data.value : "NA" }}</span>
                    </ng-container>
                    <span  *ngIf = "checklist.view_type != 'defect_sheet'">{{ data.value ? data.value : "NA" }}</span>
                  </div>
                  &nbsp; | &nbsp;
                </ng-container>
                <ng-container *ngIf = "checklist.view_type == 'defect_sheet'">
                  <span class="label-color">Total Defects : </span>
                  <span >{{ checklist.totalDefects && checklist.totalDefects>=0 ? checklist.totalDefects : "NA" }}</span>
                </ng-container>
               
              </div>
            </div>
            <div class="card">
              <ng-container
                *ngIf="
                  checklist.view_type && checklist.view_type == 'pictorial'
                "
              >
                <div #pictorialImg id = "pictorialImg" class="row">
                  <ng-container *ngFor="let data of checklist.pictorialData">
                    <div
                      [ngClass]="data.grid"
                      style="position: relative; text-align: center"
                    >
                      
                      <img  [src]="data.img_src" alt="" />
                      <ng-container *ngFor="let element of data.data">
                        <div style="position: relative">
                          <span
                            class="shift-card"
                            [ngStyle]="{ top: element.top, left: element.left }"
                          >
                            <div
                              style="
                                text-align: center;
                                color: #2a7cf6;
                                background-color: #c9dfff;
                              "
                            >
                              {{ element.data_id }}
                            </div>
                            <div
                              style="width: 100%; display: flex; height: 22px"
                            >
                              <div
                                style="
                                  width: 30%;
                                  border-bottom: 1px solid #d8d8d8;
                                  border-top: 1px solid #d8d8d8;
                                  font-size: 14px;
                                  text-align: center;
                                "
                                class="borders"
                              >
                                A
                              </div>
                              <div style="width: 70%">
                                <input
                                  type="text"
                                  disabled
                                  style="
                                    border-radius: 0px;
                                    height: 22px;
                                    color: #417cf7;
                                    font-size: 13px !important;
                                  "
                                  [(ngModel)]="element.Shift_A"
                                />
                              </div>
                            </div>
                            <div
                              style="width: 100%; display: flex; height: 22px"
                            >
                              <div
                                style="
                                  width: 30%;
                                  border-bottom: 1px solid #d8d8d8;
                                  border-top: 1px solid #d8d8d8;
                                  font-size: 14px;
                                  text-align: center;
                                "
                                class="borders"
                              >
                                B
                              </div>
                              <div style="width: 70%">
                                <input
                                  type="text"
                                  disabled
                                  style="
                                    border-radius: 0px;
                                    height: 22px;
                                    color: #417cf7;
                                    font-size: 13px !important;
                                  "
                                  [(ngModel)]="element.Shift_B"
                                />
                              </div>
                            </div>
                            <div
                              style="width: 100%; display: flex; height: 22px"
                            >
                              <div
                                style="
                                  width: 30%;
                                  border-bottom: 1px solid #d8d8d8;
                                  border-top: 1px solid #d8d8d8;
                                  font-size: 14px;
                                  text-align: center;
                                "
                                class="borders"
                              >
                                C
                              </div>
                              <div style="width: 70%">
                                <input
                                  type="text"
                                  disabled
                                  style="
                                    border-radius: 0px;
                                    height: 22px;
                                    color: #417cf7;
                                    font-size: 13px !important;
                                  "
                                  [(ngModel)]="element.Shift_C"
                                />
                              </div>
                            </div>
                          </span>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
              <ng-container *ngIf="checklist.view_type == 'defect_sheet'">
                <div id ="defectImg" class="row">
                  <ng-container *ngFor="let data of checklist.defectData; let i = index">
                    <div
                      [ngClass]="data.grid"
                      [id] = 'i'
                      style="position: relative; text-align: center;margin-top:40px;"
                    >
                      <img [id] = "checklist.checklist_name" [src]="data.img_src" alt="" />
                      <ng-container *ngFor="let element of data.data">
                        <span class="defectsPosOnImg" [ngStyle]="{ top:element.top,left: element.left }">
                          <span
                            class="defect-codes"
                            
                          >
                            <span>{{formatDefects(element.defects,'onImage')}}</span>
                          </span>
                        </span>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
              <ng-container *ngIf = "checklist.view_type == 'defect_sheet' && checklist.defectData[0].data.length">
                <table id="defectTable" class="table" >
                  <tr class="header">
                    <th>
                      Part
                    </th>
                    <th>
                      Location
                    </th>
                    <th>
                      Defects
                    </th>
                    <!-- <th>Actions</th> -->
                  </tr>
                  <ng-container *ngFor="let data of checklist.defectData[0].data; let i = index">
                    <tr>
                      <td>
                        {{data.part}}
                      </td>
                      <td>
                        {{data.location}}
                      </td>
                      <td>{{formatDefects(data.defects,'table')}}</td>
                      <!-- <td>
                        <i
                  class="fa fa-pencil icon editUserbtn action-btn"
                  title="Edit user info"
                  (click) = "popupOpen(coordinateSetting, 'defect','edit',data, i)"
                ></i>
                <i
                  class="fa fa-trash icon deleteUserBtn action-btn"
                  title="Delete"
                  (click) = "deleteDefect(checklist.defectData[0].data, i)"
                ></i>
                      </td> -->
                    </tr>
                </ng-container>
                </table>
                
              </ng-container>
              <table id="header" class="table" *ngIf="checklist?.check_points.length">
                <thead>
                  <tr>
                    <th *ngFor="let head of checklist?.headerColumns">
                      {{ head?.columnName }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of checklist?.check_points">
                    <ng-container *ngIf="data.header">
                      <div class="subHeaderStyle">
                        {{ data.header }}
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!data.header">
                      <td *ngFor="let head of checklist?.headerColumns">
                        <ng-container
                          *ngIf="tpeOf(data[head?.columnId]) == 'object'"
                        >
                          {{ formatData(data[head?.columnId]) }}
                        </ng-container>
                        <ng-container
                          *ngIf="tpeOf(data[head?.columnId]) != 'object'"
                        >
                          {{
                            data[head?.columnId]
                              ? data[head?.columnId]
                              : "------"
                          }}
                        </ng-container>
                      </td>
                    </ng-container>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    <!-- </div>
  </div> -->
</ng-template>
